import React from "react";
import { getWalletTxnDateLines } from "../../utils/walletDisplay";

const TONE_CLASS = {
  session: "text-gray-700",
  created: "text-gray-600",
  paidOn: "text-emerald-700 font-medium",
};

export default function WalletTxnDates({ txn, className = "", compact = false }) {
  const lines = getWalletTxnDateLines(txn);
  if (!lines.length) return null;

  if (compact) {
    return (
      <div className={`space-y-0.5 ${className}`}>
        {lines.map(({ key, label, value, tone }) => (
          <p key={key} className={`text-xs ${TONE_CLASS[tone] || "text-gray-500"}`}>
            <span className="font-medium text-gray-400">{label}: </span>
            {value}
          </p>
        ))}
      </div>
    );
  }

  return (
    <div className={`space-y-1.5 ${className}`}>
      {lines.map(({ key, label, value, tone }) => (
        <div key={key} className="leading-snug">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
            {label}
          </div>
          <div className={`text-xs ${TONE_CLASS[tone] || "text-gray-600"}`}>{value}</div>
        </div>
      ))}
    </div>
  );
}
